import { Container, Title, Text, Button, Stack, Paper, Code, Group } from '@mantine/core';
import { IconServerCog } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface ServerErrorPageProps {
  error?: Error;
  resetError?: () => void;
}

export function ServerErrorPage({ error, resetError }: ServerErrorPageProps) {
  const { t } = useTranslation('errors');

  const handleRetry = () => {
    if (resetError) {
      resetError();
    } else {
      window.location.reload();
    }
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <Container size="xs" mt="xl" py="xl">
      <Paper p="xl" radius="md" withBorder ta="center">
        <Stack align="center" gap="md">
          <IconServerCog size={80} style={{ color: 'var(--mantine-color-red-6)' }} />

          <Title order={2}>{t('server_error_title')}</Title>

          <Text size="sm" c="dimmed">
            {t('server_error_description')}
          </Text>

          {error && import.meta.env && import.meta.env.DEV && (
            <Code block mt="md" style={{ textAlign: 'left', width: '100%' }}>
              {error.message}
              {error.stack && `\n\n${error.stack}`}
            </Code>
          )}

          <Group mt="md">
            <Button onClick={handleRetry} variant="light">
              {t('try_again')}
            </Button>
            <Button onClick={handleGoHome}>
              {t('go_home')}
            </Button>
          </Group>
        </Stack>
      </Paper>
    </Container>
  );
}
